




























































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import RouteNames from "@/router/RouteNames";
import BecomeClient from "@/components/landing/common/BecomeClient.vue";
import { namespace } from "vuex-class";
import Auth from "@/state/Auth";

const AppModule = namespace("App");

@Component({
  components: {
    BecomeClient,
  },
  computed: {
    RouteNames() {
      return RouteNames;
    }
  }
})
export default class LandingPage extends Vue {
  @AppModule.State
  private windowWidth!: number;

  mounted(){
    this.goHomeIfNeed();
  }

  goHomeIfNeed(){
    if(Auth.getUser){
      this.$router.push({name: RouteNames.HOME});
    }
  }

  private showAllPrices = false;

  private togglePrices(): void {
    this.showAllPrices = true;
  }
}
